module.exports = __webpack_public_path__ + "img/box4_bg.9c33283a.png";